import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/app/avfallsregistret/$id'
)({
  component: () => <h1>en specifik rapportering</h1>,
})
